import { useMemo } from 'react';
import { HelpButtonToolbar } from '@sas/react-svg';
import { useIconA11yInfo } from '../../../../components/Icon/useIconA11yInfo';
import { createUseTextLocalizer } from '../../../../locale/createUseTextLocalizer';
import { formatDateRangeForSearch, formatNumericRangeForSearch } from '../borrowed/catalog-app/typescript/src/app/util/format';
import { PREVIOUS_DAY_SEARCH_VALUE, SEARCH_DELIMITER } from '../shared';
import bundle from '../../NovaComponents-CatalogSearch-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
export const useCatalogSearchHelp = ({
  facetInfo,
  enableExperimental
}) => {
  const localize = useTextLocalizer();
  const getIconA11yInfo = useIconA11yInfo();
  const suggestionHelp = useMemo(() => {
    const helpText = localize('search.suggestion.help.generic.msg');
    const helpButtonToolbarA11yInfo = getIconA11yInfo({
      icon: HelpButtonToolbar
    });
    const help = {
      label: helpText,
      icon: HelpButtonToolbar,
      // 'hide' icon from screenreader if it would just be saying the same thing
      // twice (icon tooltip & label text)
      iconAriaLabel: helpButtonToolbarA11yInfo.ariaLabel === helpText ? '' : helpButtonToolbarA11yInfo.ariaLabel,
      iconTooltip: helpButtonToolbarA11yInfo.tooltip === helpText ? '' : helpButtonToolbarA11yInfo.tooltip,
      helpId: 'infocat_search'
    };
    if (facetInfo) {
      // Dynamic helpURL determination goes here
      let helpText = localize(`search.suggestion.help.facettype.${facetInfo.valueType}.msg`);
      let helpId = 'infocat_search';
      let secondaryText = undefined;
      switch (facetInfo.valueType) {
        case 'date':
          helpId = 'date_search';
          if (facetInfo.groupingTokenType === 'bracket') {
            helpText = localize('search.suggestion.help.facettype.date.range.msg');
            const ONE_WEEK_MS = 1000 * 60 * 60 * 24 * 7;
            const startDate = new Date(new Date(Date.now() - ONE_WEEK_MS).toDateString());
            const endDate = new Date(new Date(Date.now()).toDateString());
            secondaryText = `${facetInfo.name}:${SEARCH_DELIMITER}${formatDateRangeForSearch({
              startDate,
              endDate
            })}`;
          } else if (facetInfo.groupingTokenType === 'quote') {
            secondaryText = `${facetInfo.name}:${SEARCH_DELIMITER}"${PREVIOUS_DAY_SEARCH_VALUE}"`;
          }
          break;
        case 'text':
          helpId = 'freetext_search'; // this seems to be mixing terms calling it freetext...
          break;
        case 'keyword':
          if (facetInfo.name === 'Locale') {
            helpText = localize('search.suggestion.help.facettype.locale.msg');
            helpId = 'locale_search';
          } else {
            helpId = 'keyword_search';
          }
          break;
        case 'nested':
          helpId = 'nested_search';
          break;
        case 'integer':
        case 'long':
          helpId = 'numeric_search';
          if (facetInfo.groupingTokenType === 'bracket') {
            helpText = localize(`search.suggestion.help.facettype.${facetInfo.valueType}.range.msg`);
            secondaryText = `${facetInfo.name}:${SEARCH_DELIMITER}${formatNumericRangeForSearch({
              start: 0,
              end: 100,
              valueType: facetInfo.valueType
            })}`;
          } else {
            secondaryText = `${facetInfo.name + SEARCH_DELIMITER}<50`;
          }
          break;
        case 'float':
          helpId = 'numeric_search';
          if (facetInfo.groupingTokenType === 'bracket') {
            helpText = localize('search.suggestion.help.facettype.float.range.msg');
            secondaryText = `${facetInfo.name}:${SEARCH_DELIMITER}${formatNumericRangeForSearch({
              start: 0,
              end: 100,
              valueType: facetInfo.valueType
            })}`;
          } else {
            secondaryText = `${facetInfo.name + SEARCH_DELIMITER}<50.00`;
          }
          break;
      }
      if (!helpText.startsWith('NovaComponents')) {
        help.label = helpText;
        help.icon = HelpButtonToolbar;
        // 'hide' icon from screenreader if it would just be saying the same thing
        // twice (icon tooltip & label text)
        help.iconAriaLabel = helpButtonToolbarA11yInfo.ariaLabel === helpText ? '' : helpButtonToolbarA11yInfo.ariaLabel;
        help.iconTooltip = helpButtonToolbarA11yInfo.tooltip === helpText ? '' : helpButtonToolbarA11yInfo.tooltip;
        help.helpId = helpId;
        help.example = enableExperimental ? secondaryText : undefined;
      }
    }
    return help;
  }, [localize, getIconA11yInfo, facetInfo, enableExperimental]);
  return suggestionHelp;
};
//# sourceMappingURL=useCatalogSearchHelp.js.map